export enum InitializationStateEnum {
    AWAITING,
    INITIALIZING,
    INITIALIZED
}
